/* eslint-disable no-console */
import { isProduction } from 'utils/url';

type LogType = 'log' | 'warn' | 'error' | 'info' | 'debug';

export function throwMessage(logType: LogType, message: string): void {
    if (!isProduction) {
        console[logType](message);
    }
}
